import React, {PureComponent} from 'react';
import KickImage from 'Reuseables/KickImage';
import {Card,CardImg,CardText, CardBody} from 'reactstrap';
import PropTypes from 'prop-types';

import { getCacheImage } from '../../../../config'
import { getCloudImageUrl, emptyImage } from "../../../../utils";

const onErrorImg = (e, category) => {
  e.target.src = emptyImage(category)
}
export default class Thumbnail extends PureComponent{
  render(){
    const { src, alt, category, ...props } = this.props;
      return(
        <div {...props}>
          <div className="img-container">
            <KickImage 
              src={getCloudImageUrl(src, 400)}
              alt={alt}
              onError={(e) => onErrorImg(e, category)}
              />
          </div>
        </div>
      )
  }
}
Thumbnail.propTypes={
    src:PropTypes.string,
    alt:PropTypes.string
}
Thumbnail.defaultProps={
    src:'http://via.placeholder.com/350x150',
    alt:'No Images'
}